'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var Block = require('ipfs-block');

var pull = require('pull-stream');

var CID = require('cids');

var doUntil = require('async/doUntil');

var IPFSRepo = require('ipfs-repo');

var BlockService = require('ipfs-block-service');

var joinPath = require('path').join;

var osPathSep = require('path').sep;

var pullDeferSource = require('pull-defer').source;

var pullTraverse = require('pull-traverse');

var map = require('async/map');

var series = require('async/series');

var waterfall = require('async/waterfall');

var MemoryStore = require('interface-datastore').MemoryDatastore;

var mergeOptions = require('merge-options');

var ipldDagCbor = require('ipld-dag-cbor');

var ipldDagPb = require('ipld-dag-pb');

var ipldRaw = require('ipld-raw');

function noop() {}

var IPLDResolver =
/*#__PURE__*/
function () {
  function IPLDResolver(userOptions) {
    var _this = this;

    _classCallCheck(this, IPLDResolver);

    var options = mergeOptions(IPLDResolver.defaultOptions, userOptions);

    if (!options.blockService) {
      throw new Error('Missing blockservice');
    }

    this.bs = options.blockService; // Object with current list of active resolvers

    this.resolvers = {}; // API entry point

    this.support = {}; // Adds support for an IPLD format

    this.support.add = function (multicodec, resolver, util) {
      if (_this.resolvers[multicodec]) {
        throw new Error('Resolver already exists for codec "' + multicodec + '"');
      }

      _this.resolvers[multicodec] = {
        resolver: resolver,
        util: util
      };
    };

    this.support.load = options.loadFormat || function (codec, callback) {
      callback(new Error("No resolver found for codec \"".concat(codec, "\"")));
    };

    this.support.rm = function (multicodec) {
      if (_this.resolvers[multicodec]) {
        delete _this.resolvers[multicodec];
      }
    }; // Enable all supplied formats


    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = options.formats[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var format = _step.value;
        var resolver = format.resolver,
            util = format.util;
        var multicodec = resolver.multicodec;
        this.support.add(multicodec, resolver, util);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }

  _createClass(IPLDResolver, [{
    key: "get",
    value: function get(cid, path, options, callback) {
      var _this2 = this;

      if (typeof path === 'function') {
        callback = path;
        path = undefined;
      }

      if (typeof options === 'function') {
        callback = options;
        options = {};
      } // this removes occurrences of ./, //, ../
      // makes sure that path never starts with ./ or /
      // path.join is OS specific. Need to convert back to POSIX format.


      if (typeof path === 'string') {
        path = joinPath('/', path).substr(1).split(osPathSep).join('/');
      }

      if (path === '' || !path) {
        return this._get(cid, function (err, node) {
          if (err) {
            return callback(err);
          }

          callback(null, {
            value: node,
            remainderPath: ''
          });
        });
      }

      var value;
      doUntil(function (cb) {
        _this2._getFormat(cid.codec, function (err, format) {
          if (err) return cb(err); // get block
          // use local resolver
          // update path value

          _this2.bs.get(cid, function (err, block) {
            if (err) {
              return cb(err);
            }

            format.resolver.resolve(block.data, path, function (err, result) {
              if (err) {
                return cb(err);
              }

              value = result.value;
              path = result.remainderPath;
              cb();
            });
          });
        });
      }, function () {
        var endReached = !path || path === '' || path === '/';
        var isTerminal = value && !IPLDResolver._maybeCID(value);

        if (endReached && isTerminal || options.localResolve) {
          return true;
        } else {
          value = IPLDResolver._maybeCID(value); // continue traversing

          if (value) {
            cid = value;
          }

          return false;
        }
      }, function (err, results) {
        if (err) {
          return callback(err);
        }

        return callback(null, {
          value: value,
          remainderPath: path
        });
      });
    }
  }, {
    key: "getStream",
    value: function getStream(cid, path, options) {
      var deferred = pullDeferSource();
      this.get(cid, path, options, function (err, result) {
        if (err) {
          return deferred.resolve(pull.error(err));
        }

        deferred.resolve(pull.values([result]));
      });
      return deferred;
    }
    /**
     * Get multiple nodes back from an array of CIDs.
     *
     * @param {Array<CID>} cids
     * @param {function(Error, Array)} callback
     * @returns {void}
     */

  }, {
    key: "getMany",
    value: function getMany(cids, callback) {
      var _this3 = this;

      if (!Array.isArray(cids)) {
        return callback(new Error('Argument must be an array of CIDs'));
      }

      this.bs.getMany(cids, function (err, blocks) {
        if (err) {
          return callback(err);
        }

        map(blocks, function (block, mapCallback) {
          _this3._getFormat(block.cid.codec, function (err, format) {
            if (err) return mapCallback(err);
            format.util.deserialize(block.data, mapCallback);
          });
        }, callback);
      });
    }
  }, {
    key: "put",
    value: function put(node, options, callback) {
      var _this4 = this;

      if (typeof options === 'function') {
        callback = options;
        return setImmediate(function () {
          return callback(new Error('IPLDResolver.put requires options'));
        });
      }

      callback = callback || noop;

      if (options.cid && CID.isCID(options.cid)) {
        if (options.onlyHash) {
          return setImmediate(function () {
            return callback(null, options.cid);
          });
        }

        return this._put(options.cid, node, callback);
      }

      this._getFormat(options.format, function (err, format) {
        if (err) return callback(err);
        format.util.cid(node, options, function (err, cid) {
          if (err) {
            return callback(err);
          }

          if (options.onlyHash) {
            return callback(null, cid);
          }

          _this4._put(cid, node, callback);
        });
      });
    }
  }, {
    key: "treeStream",
    value: function treeStream(cid, path, options) {
      var _this5 = this;

      if (typeof path === 'object') {
        options = path;
        path = undefined;
      }

      options = options || {};
      var p;

      if (!options.recursive) {
        p = pullDeferSource();
        waterfall([function (cb) {
          return _this5._getFormat(cid.codec, cb);
        }, function (format, cb) {
          return _this5.bs.get(cid, function (err, block) {
            if (err) return cb(err);
            cb(null, format, block);
          });
        }, function (format, block, cb) {
          return format.resolver.tree(block.data, cb);
        }], function (err, paths) {
          if (err) {
            p.abort(err);
            return p;
          }

          p.resolve(pull.values(paths));
        });
      } // recursive


      if (options.recursive) {
        p = pull(pullTraverse.widthFirst({
          basePath: null,
          cid: cid
        }, function (el) {
          // pass the paths through the pushable pull stream
          // continue traversing the graph by returning
          // the next cids with deferred
          if (typeof el === 'string') {
            return pull.empty();
          }

          var deferred = pullDeferSource();
          var cid = el.cid;
          waterfall([function (cb) {
            return _this5._getFormat(cid.codec, cb);
          }, function (format, cb) {
            return _this5.bs.get(cid, function (err, block) {
              if (err) return cb(err);
              cb(null, format, block);
            });
          }, function (format, block, cb) {
            return format.resolver.tree(block.data, function (err, paths) {
              if (err) {
                return cb(err);
              }

              map(paths, function (p, cb) {
                format.resolver.isLink(block.data, p, function (err, link) {
                  if (err) {
                    return cb(err);
                  }

                  cb(null, {
                    path: p,
                    link: link
                  });
                });
              }, cb);
            });
          }], function (err, paths) {
            if (err) {
              deferred.abort(err);
              return deferred;
            }

            deferred.resolve(pull.values(paths.map(function (p) {
              var base = el.basePath ? el.basePath + '/' + p.path : p.path;

              if (p.link) {
                return {
                  basePath: base,
                  cid: IPLDResolver._maybeCID(p.link)
                };
              }

              return base;
            })));
          });
          return deferred;
        }), pull.map(function (e) {
          if (typeof e === 'string') {
            return e;
          }

          return e.basePath;
        }), pull.filter(Boolean));
      } // filter out by path


      if (path) {
        return pull(p, pull.map(function (el) {
          if (el.indexOf(path) === 0) {
            el = el.slice(path.length + 1);
            return el;
          }
        }), pull.filter(Boolean));
      }

      return p;
    }
  }, {
    key: "remove",
    value: function remove(cids, callback) {
      this.bs.delete(cids, callback);
    }
    /*           */

    /* internals */

    /*           */

  }, {
    key: "_get",
    value: function _get(cid, callback) {
      var _this6 = this;

      waterfall([function (cb) {
        return _this6._getFormat(cid.codec, cb);
      }, function (format, cb) {
        return _this6.bs.get(cid, function (err, block) {
          if (err) return cb(err);
          cb(null, format, block);
        });
      }, function (format, block, cb) {
        format.util.deserialize(block.data, function (err, deserialized) {
          if (err) {
            return cb(err);
          }

          cb(null, deserialized);
        });
      }], callback);
    }
  }, {
    key: "_getFormat",
    value: function _getFormat(codec, callback) {
      var _this7 = this;

      if (this.resolvers[codec]) {
        return callback(null, this.resolvers[codec]);
      } // If not supported, attempt to dynamically load this format


      this.support.load(codec, function (err, format) {
        if (err) return callback(err);
        _this7.resolvers[codec] = format;
        callback(null, format);
      });
    }
  }, {
    key: "_put",
    value: function _put(cid, node, callback) {
      var _this8 = this;

      callback = callback || noop;
      waterfall([function (cb) {
        return _this8._getFormat(cid.codec, cb);
      }, function (format, cb) {
        return format.util.serialize(node, cb);
      }, function (buf, cb) {
        return _this8.bs.put(new Block(buf, cid), cb);
      }], function (err) {
        if (err) {
          return callback(err);
        }

        callback(null, cid);
      });
    }
    /**
     * Return a CID instance if it is a link.
     *
     * If something is a link `{"/": "baseencodedcid"}` or a CID, then return
     * a CID object, else return `null`.
     *
     * @param {*} link - The object to check
     * @returns {?CID} - A CID instance
     */

  }], [{
    key: "_maybeCID",
    value: function _maybeCID(link) {
      if (CID.isCID(link)) {
        return link;
      }

      if (link && link['/'] !== undefined) {
        return new CID(link['/']);
      }

      return null;
    }
  }]);

  return IPLDResolver;
}();
/**
 * Default options for IPLD.
 */


IPLDResolver.defaultOptions = {
  formats: [ipldDagCbor, ipldDagPb, ipldRaw]
  /**
   * Create an IPLD resolver with an in memory blockservice and
   * repo.
   *
   * @param {function(Error, IPLDResolver)} callback
   * @returns {void}
   */

};

IPLDResolver.inMemory = function (callback) {
  var repo = new IPFSRepo('in-memory', {
    storageBackends: {
      root: MemoryStore,
      blocks: MemoryStore,
      datastore: MemoryStore
    },
    lock: 'memory'
  });
  var blockService = new BlockService(repo);
  series([function (cb) {
    return repo.init({}, cb);
  }, function (cb) {
    return repo.open(cb);
  }], function (err) {
    if (err) {
      return callback(err);
    }

    callback(null, new IPLDResolver({
      blockService: blockService
    }));
  });
};

module.exports = IPLDResolver;